import { IntegerCodeNameResponse, ConstructionTypesApiFactory } from '@/api'
import { BaseMasterListRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 工事種別一覧取得処理
 */
export class ReadRequest extends BaseMasterListRequest {
  protected request(): AxiosPromise<IntegerCodeNameResponse> {
    const api = ConstructionTypesApiFactory()
    return api.constructionTypesList({ cache: true })
  }
}
